import {connect} from "redux-vue";
import ModalTemplate from "./ModalTemplate";
import * as appActions from "../actions/app";
import * as actionActions from "../actions/action";
import {
  ANY_FACILITY,
  ANY_STAKEHOLDER,
  ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60
} from "../../simulation/factories/actions";
import classNames from "classnames";
import {testStakeholderIsStaff} from "../helpers/tools";

const ActionModal = {
  props: ['app', 'action', 'actions', 'locations', 'setAction', 'takeAction', 'goTo'],

  /**
   *
   * @returns {{selectOption: null, selectOpen: boolean}}
   */
  data() {
    return {
      selectOpen: false,
      selectOption: null,
    }
  },

  /**
   *
   */
  methods: {
    handleCancel() {
      this.setAction(null);
      this.selectOption = null;
    },
    handleOk() {
      if (this.selectConfig.options > 0 && !this.selectOption) return;
      const action_results = this.action.model.action_results.filter(this.filterActionResults);
      this.takeAction({
        ...this.action.model,
        action_results,
      });
      this.selectOption = null;
    },
    toggleSelect() {
      this.selectOpen = !this.selectOpen;
    },
    handleSelect(option) {
      return () => this.selectOption = option;
    },
    filterActionResults(each) {
      if (!this.selectOption) return true;
      if (this.action.model.targeted === ANY_FACILITY) {
        return each.location === this.selectOption.value.id
      }
      if ([ANY_STAKEHOLDER, ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60].includes(
        this.action.model.targeted
      )) {
        return (this.selectOption.value.id === each.stakeholder || this.selectOption.value.title.includes(each.stakeholder))
          && each.location === this.selectOption.value.location;
      }
      return true;
    }
  },

  /**
   *
   */
  computed: {
    selectConfig() {
      let options = [];
      let label = "";
      if (
        this.action.model.targeted === ANY_STAKEHOLDER ||
        this.action.model.targeted === ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60
      ) {
        label = "Select Stakeholder";
        options = this.locations.collection
          .map(eachLocation =>
            eachLocation.stakeholders.filter(testStakeholderIsStaff).map(eachStakeholder => ({
              label: eachLocation.id === 'DHT'
                ? eachStakeholder.title
                : eachLocation.name + " " + eachStakeholder.title,
              value: {
                ...eachStakeholder,
                location: eachLocation.id
              },
            })))
          .reduce((a, b) => a.concat(b), []);
        if (this.action.model.targeted === ANY_STAKEHOLDER_WITH_MOTIVATION_LESS_THAN_60) {
          options = options.filter(each => each.value.motivation && each.value.motivation < 60);
        }
      }
      if (this.action.model.targeted === ANY_FACILITY) {
        label = "Select Facility";
        options = this.locations.collection
          .filter(each => each.id !== "DHT")
          .map(each => ({
            label: each.name,
            value: each
          }));
      }
      return {options, label};
    },
  },

  /**
   *
   * @param h
   * @returns {null|*}
   */
  render(h) {
    if (!this.action.model || this.app.completed) {
      return null;
    }
    const menuContainerClass = classNames(
      "shadow hover:shadow-lg mt-6 text-lg lg:text-xl relative w-full lg:w-auto select-none",
      {'bg-brand-orange-700': !this.selectOption}
    );
    const menuClass = classNames(
      "flex items-center leading-none text-white lg:py-1 lg:px-12 justify-center shadow cursor-pointer",
      this.selectOption ? 'text-brand-blue-500' : 'text-white'
    );
    const menuArrowClass = classNames(
      "mdi mdi-menu-right transform transition ease-in-out duration-200 text-4xl -translate-x-2 translate-y-px",
      {'rotate-90 -translate-y-px': this.selectOpen, 'text-brand-gray-500': this.selectOption }
    );
    const selectMenu = this.selectConfig.options.length > 0 && (
      <div class={menuContainerClass}>
        <div onClick={this.toggleSelect} class={menuClass}>
          <span>{this.selectOption ? this.selectOption.label : this.selectConfig.label}</span>
          <i class={menuArrowClass}></i>
        </div>
        <transition
          name="custom-classes-transition"
          enter-active-class="transition ease-out duration-100 transform"
          enter-class="opacity-0 scale-95"
          enter-to-class="opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75 transform"
          leave-class="opacity-100 scale-100"
          leave-to-class="opacity-0 scale-95"
        >
          {this.selectOpen && (
            <div class="origin-top absolute left-0 w-full shadow-lg">
              <ul onClick={this.toggleSelect} class="bg-white shadow-sm text-brand-blue-500 left-0 cursor-pointer overflow-y-auto text-center" style="max-height: 16rem;">
                {this.selectConfig.options.length > 0 && this.selectConfig.options.map(each => (
                  <li class="py-1" key={each.label} onClick={this.handleSelect(each)}>
                    {each.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </transition>
      </div>
    );
    const disableOk = this.selectConfig.options.length > 0 && !this.selectOption;
    const okClass = classNames(
      "rounded-full p-10 py-1 text-white uppercase text-sm font-bold focus:outline-none",
      disableOk ? 'bg-gray-300 cursor-not-allowed' : 'bg-brand-green-400'
    );
    return (
      <ModalTemplate>
        <div class="max-h-75screen py-12 lg:pt-24">
          <div class="w-10/12 mx-auto lg:text-lg flex flex-col items-start">
            <p class="text-2xl lg:text-3xl font-bold leading-none">
              You have selected the action:
            </p>

            <p class="my-3">
              {this.action.model.action}
            </p>

            <p class="mb-4">
              This action will require {this.action.model.weeks_required}
              {this.action.model.weeks_required === 1 ? ' week' : ' weeks'} to implement.
            </p>

            {this.selectConfig.options.length > 0 && (
              <p class="">
                {this.action.model.id === "TP4"
                  ? "Which facility staff would you like to send on this “go and see”?"
                  : "With which change stakeholder would you like to take this action?"
                }
              </p>
            )}

            {selectMenu}

            <p class="">
              Select <strong>OK</strong> to confirm or <strong>Cancel</strong> to select a different action.
            </p>

            <div class="flex items-center mt-8">
              <button onClick={this.handleCancel} type="button" class="rounded-full bg-brand-red-500 p-5 py-1 text-white uppercase text-sm font-bold focus:outline-none">
                Cancel
              </button>
              <div class="w-5"></div>
              <button onClick={this.handleOk} disabled={disableOk} type="button" class={okClass}>
                Ok
              </button>
            </div>
          </div>
        </div>
      </ModalTemplate>
    );
  }
};

function mapStateToProps(state) {
  return {
    app: state.simulation.app,
    action: state.simulation.action,
    actions: state.simulation.actions,
    locations: state.simulation.locations,
  };
}

function mapActionToProps(dispatch) {
  return {
    goTo: (slide) => dispatch(appActions.goTo(slide)),
    setAction: (action) => dispatch(actionActions.setAction(action)),
    takeAction: (action) => dispatch(actionActions.takeAction(action)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(ActionModal);
